import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count"]
  static values = { max: { type: Number, default: 5 } }

  connect() {
    this.maxCategories = this.maxValue
    this.updateCount()
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  handleSubmitEnd = (event) => {
    if (event.detail.success) {
      this.element.closest("dialog")?.close()
    }
  }

  updateCount() {
    const checked = this.checkboxTargets.filter(cb => cb.checked).length
    this.countTarget.textContent = checked

    // 最大件数(PostCategorizable::MAX_CATEGORIES_PER_POST)までの制御
    this.checkboxTargets.forEach(cb => {
      if (!cb.checked && checked >= this.maxCategories) {
        cb.disabled = true
        cb.closest("label")?.classList.add("opacity-50", "cursor-not-allowed")
      } else {
        cb.disabled = false
        cb.closest("label")?.classList.remove("opacity-50", "cursor-not-allowed")
      }
    })
  }
}
